import joinClasses from "helpers/joinClasses";

export function YellowBloc({className=""}) {
    return (
      <div className={joinClasses(className,"md:absolute md:inline-flex  md:bg-yellow-lightest md:-z-10  md:w-screen md:min-h-full")} style={{
        background:
          "linear-gradient(90deg, #faf6f0 36%, #fff 0.1%, #fff 64%)",
      }}></div>
    )
  }